// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"styles_subTitle__3WvjZ","grayText":"styles_grayText__2ItWl","list":"styles_list__34Lu9","separator":"styles_separator__1Bzbc"};